import { Button } from '@/components/button';
import classNames from 'classnames';

import classes from './HighlightCard.module.scss';

export type HighlightCardProps = {
  subtitle: string;
  title: string;
  link?: string;
  label?: string;
  className?: string;
  variant?: 'green';
};

const HighlightCardComponent: React.FC<HighlightCardProps> = ({ subtitle, title, link, label, className, variant }) => {
  return (
    <div className={classNames(classes.highlightCard, className, { [classes.green]: variant === 'green' })}>
      <div className={classes.subtitle}>{subtitle}</div>
      <div className={classes.title}>{title}</div>
      {link && label && (
        <Button data-testid="highlight-card-action-button" className={classes.button} variant="ctaFull" link={link}>
          {label}
        </Button>
      )}
    </div>
  );
};

export default HighlightCardComponent;
